import {FC} from 'react'

import {BUTTON_BORDER_RADIUS} from '@/components/common/content/Button'
import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {SkeletonBlock} from '@/components/common/skeleton/SkeletonBlock'
import {SkeletonLoadingOverlay} from '@/components/common/skeleton/SkeletonLoadingOverlay'
import {useHeaderContent} from '@/content/header'
import {useTranslation} from '@/i18n'
import {ICON_SIZE_MEDIUM} from '@/theme/icons'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

// Shown before auth resolves. Same for everyone to stay cacheable, sized like LoginButton so
// nothing shifts on swap; label text is real but invisible, just reserving width per locale.
export const HeaderAuthPlaceholder: FC = () => {
  const {t} = useTranslation('page')
  const {loginButtonText} = useHeaderContent()

  return (
    <>
      <SkeletonLoadingOverlay
        borderRadius={BUTTON_BORDER_RADIUS}
        highlightColor={theme.palette.skeletonLoading.highlight.onDark}
      >
        <span className="placeholder" aria-hidden="true">
          <SkeletonBlock
            width={ICON_SIZE_MEDIUM}
            height={ICON_SIZE_MEDIUM}
            borderRadius="50%"
            flex={`0 0 ${ICON_SIZE_MEDIUM}`}
            color={theme.palette.skeletonLoading.dark}
          />
          <span className="placeholder-label">
            <Text
              variant={TextVariant.subtitle12}
              fontWeight={TextFontWeight.semibold}
              color="transparent"
              className="text-block"
            >
              {t(loginButtonText)}
            </Text>
          </span>
        </span>
      </SkeletonLoadingOverlay>

      <style jsx>{`
        .placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: ${theme.spacing[2]};
          min-height: 40px;
          padding: 10px;
          border: 1px solid ${theme.palette.button.darkGray.outlineColor};
          border-radius: ${BUTTON_BORDER_RADIUS}px;
          background-color: ${theme.palette.button.darkGray.main};
        }
        .placeholder-label {
          display: block;
          border-radius: 4px;
          background-color: ${theme.palette.skeletonLoading.dark};
        }
        @media ${MOBILE_SCREENSIZE} {
          .placeholder-label {
            display: none;
          }
        }
      `}</style>
    </>
  )
}
